import { createContext, useContext, useEffect, useState } from "react";
import { api, TOKEN_KEY } from "@/lib/api";

const AuthCtx = createContext(null);
const LANG_KEY = "mline_lang";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      setUser(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem(TOKEN_KEY);
        setUser(false);
      });
  }, []);

  const login = (token, u) => {
    localStorage.setItem(TOKEN_KEY, token);
    if (u.language) localStorage.setItem(LANG_KEY, u.language);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export function useLang() {
  const { user, setUser } = useAuth();
  const [local, setLocal] = useState(localStorage.getItem(LANG_KEY) || "ro");
  const lang = user?.language || local;
  const setLang = (l) => {
    localStorage.setItem(LANG_KEY, l);
    setLocal(l);
    if (user) {
      setUser({ ...user, language: l });
      api.put("/auth/me/language", { language: l }).catch(() => {});
    }
  };
  return [lang, setLang];
}
